<template>
  <div id="app" class="container text-big">
    <div style="height: 40px"></div>
    <h1>
      Gyre Ui Development Mode
      <br />
      <small>Proxying against {{ proxyUrl }}</small>
    </h1>

    <div style="height: 30px"></div>
    <p>
      Gyre uses a proxy so that you can use Hot Module Replacement against the main Gyre site. Click
      the Home button to try that out. You need to be running the site through Visual Studio for
      that to work. If you're redirected to this page from somewhere else, this page will redirect
      you on to "/home".
    </p>

    <p>
      You can also develop ui against characterscope-dev.azurewebsites.net by running 'npm run
      serve:cs-dev".
    </p>

    <div
      style="position: absolute; width: 100%; height: 70px; top: 0; left: 0; background: #f2f2f2"
    >
      <a href="/home" style="position: absolute; top: 14px; left: 15px; font-size: 30px">
        <img
          src="./assets/brand/gyre-icon-sm-rounded.png"
          style="width: 30px; position: relative; top: -5px"
          alt="brand icon"
        />
        Home
      </a>
    </div>

    <a href="/demo" style="position: absolute; top: 14px; right: 240px; font-size: 30px"
      ><span class="glyphicon glyphicon-play-circle"></span> Demos
    </a>

    <a href="/test" style="position: absolute; top: 14px; right: 15px; font-size: 30px"
      ><span class="glyphicon glyphicon-list-alt"></span> Test Panel
    </a>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, computed } from "vue";
import cms from "./services/cms/cms";

const proxyUrl = computed(() => process.env.VUE_APP_MY_CS_URL);

onMounted(() => {
  cms.handlePreviewing();
  if (document.referrer && document.referrer.includes("localhost")) {
    window.location.replace("/home");
  }
});
</script>

<style scoped lang="less">
h1 {
  margin-top: 8rem;
}

.a-unstyled {
  margin-top: 8rem;
}
</style>
